module.exports = __webpack_public_path__ + "static/img/wx_tips.bc63d78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wx_tips.jpg
// module id = 303
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12